@if (show) {
  <div class="custom-popup task-supervisor-popup modal left fade">
    <div class="modal-dialog" (clickOutside)="showSegReport ? hideTaskSupervisorFn($event) : hideFormFn()">
      <div class="modal-content">
        <div class="modal-header {{selectedSEG?'with-seg':''}}">
          @if (showSegReport) {
            <h4 class="modal-title card-title">
              <span class="d-block small-light-text">{{ 'Task' | translate }}</span>
              {{selectedTask?.taskName}}
            </h4>
          }
          @if (!showSegReport && selectedSEG) {
            <h4 class="modal-title card-title">
              <span class="d-block small-light-text">{{ 'SEG' | translate }}</span>
              {{selectedSEG?.segName}}
            </h4>
          }
          <button class="close" type="button" (click)="hideTaskSupervisorFn($event)"><span>×</span></button>
        </div>
        @if (!showSegReport) {
          <span class="material-icons back-arrow" (click)="hideForm()">chevron_left</span>
        }
        @if (selectedSEG) {
          <div class="modal-header seg-header">
            @if (showSegReport) {
              <h4 class="modal-title card-title">
                <span class="d-block small-light-text">{{ 'SEG' | translate }}</span>
                {{selectedSEG?.segName}}
              </h4>
            }
            @if (!showSegReport) {
              <h4 class="modal-title card-title">
                <span class="d-block">{{ 'Task Group' | translate }}</span>
                <span class="report-title">{{selectedTask?.taskName}}</span>
              </h4>
            }
          </div>
        }
        <div class="modal-body">
          @if (showSegReport) {
            <app-associated-segs
              [loadingAllSEGs]="loadingAllSEGs"
              [exposureAllSEGs]="exposureAllSEGs">
            </app-associated-segs>
            <app-task-distribution
              [loadingExposureTaskDistribution]="loadingExposureTaskDistribution"
              [exposureTaskDistributions]="exposureTaskDistributions">
            </app-task-distribution>
            <app-task-samples
              [loadingExposureTaskSamples]="loadingExposureTaskSamples"
              [exposureTaskSamples]="exposureTaskSamples" (sortExposureTaskSamplesEmit)="sortExposureTaskSamples($event)">
            </app-task-samples>
          }
          @if (!showSegReport) {
            <app-task-report
              [segTasks]="segTasks"
              >
            </app-task-report>
          }
        </div>
      </div>
    </div>
  </div>
}
